export default "__VITE_ASSET__Cin7NCH3__"